<template>
<div class="container" id="popup-notification">

    <!-- MAIN MODAL -->
    <div v-if="mainModal">
    <transition name="modal" mode="out-in">
        <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container popup-notification__modal mainModal">
            <div class="modal-body">
                <slot name="body">
                <div>
                    <div class="flex">
                    <img :src="dataRating.brand.img">{{ dataRating.benefit_subtitle }}
                    </div><br/>
                    <div class="text-center mt-3">
                    <h4> &#191;Utiliz&oacute; este beneficio&#63;	 </h4>
                    </div><br/>
                    <div class="text-center mt-3">
                    <button @click="responseMainModal('no')" class="no">No</button>
                    <button @click="responseMainModal('yes')" class="yes">S&iacute;</button>
                    </div><br/>
                </div>
                </slot>
            </div>
            </div>
        </div>
        </div>
    </transition>
    </div>
    
    <!-- NO MODAL -->
    <div v-if="noModal">
    <transition name="modal" mode="out-in">
        <div class="modal-mask">
        <div class="modal-wrapper">
            
            <div class="modal-container popup-notification__modal mainModal">
            <div > 
                <div class="close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="noModal = !noModal">
                    <path d="M18 6L6 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M6 6L18 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                </div>
            </div>
            <div class="modal-body">
                <slot name="body">
                <div>
                    <div class="text-center">
                    <h4> &#161;Cuéntanos&#33; &#191;Por qué no <br>utilizaste el beneficio&#63; </h4>
                    <br/>
                    <input type="text" v-model="responseClient.comment" placeholder="Déjanos tu comentario" maxlength="250">
                    <p class="" :class="[!responseClient.comment.length ? 'popup-text-light' : 'popup-text-primary']">{{ responseClient.comment.length }}<span class=" popup-text-light"> / </span><span class="" :class="[responseClient.comment.length ? 'popup-text-light' : 'popup-text-primary']">250 caracteres máximo.</span></p>
                    </div><br/><br/>
                    <div class="text-center mt-3">
                    <button @click="sendModal()" class="yes">Enviar</button>
                    </div>
                </div>
                </slot>
            </div>
            </div>
        </div>
        </div>
    </transition>
    </div>

    <!-- YES MODAL -->
    <div v-if="yesModal">
    <transition name="modal" mode="out-in">
        <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container popup-notification__modal mainModal">
            <div > 
                <div class="close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="yesModal = !yesModal">
                    <path d="M18 6L6 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M6 6L18 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                </div>
            </div>
            <div class="modal-body">
                <slot name="body">
                <div>
                    <div class="flex">
                        <img :src="dataRating.brand.img">{{ dataRating.benefit_subtitle }}
                    </div>
                    <div v-if="!responseClient.rating_value">
                        <br/>
                        <div class="text-center mt-3">
                            <h4> 
                                Del 0 al 10,  ¿qué tan probable
                                es que nos recomiendes a familiares o amigos?
                            </h4>
                            <div class="nps-benefit-rating">
                                <ul class="score-list">
                                    <PopupNpsList 
                                    v-for="scoreItem in scoreData"
                                    :key="scoreItem.id"
                                    :scoreItem="scoreItem"
                                    :scoreVal="score"
                                    @select="selectScoreNps"
                                    :class="{'high-score': scoreItem.id > 8, 'low-score': scoreItem.id < 7}">
                                    </PopupNpsList>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <br/>
                        <div class="text-center">
                            <input type="text" v-model="responseClient.comment" placeholder="Déjanos tu comentario" maxlength="250">
                            <p class="" :class="[!responseClient.comment.length ? 'popup-text-light' : 'popup-text-primary']">{{ responseClient.comment.length }}<span class=" popup-text-light"> / </span><span class="" :class="[responseClient.comment.length ? 'popup-text-light' : 'popup-text-primary']">250 caracteres máximo.&nbsp;&nbsp;&nbsp;&nbsp;</span></p>
                        </div><br/>
                        <div class="text-center mt-3" v-if="responseClient.rating_value">
                            <button @click="sendModal()" class="yes">Enviar</button>
                        </div>
                    </div>
                </div>
                </slot>
            </div>
            </div>
        </div>
        </div>
    </transition>
    </div>

    <!-- MODAL -->
    <div v-if="gratitudeModal">
    <transition name="modal" mode="out-in">
        <div class="modal-mask">
        <div class="modal-wrapper">
            
            <div class="modal-container popup-notification__modal mainModal">
            <div > 
                <div class="close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="gratitudeModal = !gratitudeModal">
                    <path d="M18 6L6 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M6 6L18 18" stroke="#C9C9C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                </div>
            </div>
            <div class="modal-body">
                <slot name="body">
                <div>
                    <div class="text-center">
                    <img src="https://storage.googleapis.com/vivemas/is-popup-notifications/agradecimiento_popup.svg" alt="agradecimiento" />
                    </div>
                    <br>
                    <div class="text-center">
                    <h4> &#161;Muchas gracias por compartir tu experiencia&#33; </h4>
                    </div>
                </div>
                </slot>
            </div>
            </div>
        </div>
        </div>
    </transition>
    </div>
    <!-- Loader -->
    <div id="modal-loader" v-if="loader">
    <transition name="modal">
        <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
            <div class="modal-body">
                <slot name="body">
                <div class="bg-loader">
                    <p> Cargando...</p>
                    <div class="progress">
                    <div class="">
                    
                    </div>
                    </div>
                </div>
                </slot>
            </div>
            </div>
        </div>
        </div>
    </transition>
    </div>
</div>
</template>


<script>

import PopupNpsList from '@/components/modals/nps/PopupNpsList'

export default {
    name: 'PopupNotification',
    components: {
        PopupNpsList,
    },
    props: {
    api: {
        type: Object,
        required: true
    },
    query: {
        type: Object
    },
    origin: {
        type: String,
        required: false,
        default: 'MODO PRUEBAS'
    },
    },
    data: function() {
    return {
        rating: 0, // Guardará el valor de la calificación final
        temporaryRating: 0, // Guardará el valor temporal al pasar el ratón por las estrellas
        half: false,
        isRatingSet: false, // Controla si la calificación se ha fijado
        selectedScoreInfo: [],
        dataRating: [],
        param: {},
        loader: true,
        mainModal: false,
        yesModal: false,
        noModal: false,
        gratitudeModal: false,
        comment: 'any comment',
        responseClient: {
            id: null,
            benefit_use: '',
            rating_value: 0,
            comment: ''
        },
        scoreData: [
            {
            id: 0,
            img: require('@/assets/nps/person-0-1-2.svg'),
            meaning: 'Nada probable',
            instruction: [
                { bold: false, text: 'Lamentamos lo sucedido, ' },
                { bold: true, text: '¿qué salió mal? ' }
            ],
            nps: 'detractor'
            },
            {
            id: 1,
            img: require('@/assets/nps/person-0-1-2.svg'),
            meaning: 'Nada probable',
            instruction: [
                { bold: false, text: 'Lamentamos lo sucedido, ' },
                { bold: true, text: '¿qué salió mal? ' }
            ],
            nps: 'detractor'
            },
            {
            id: 2,
            img: require('@/assets/nps/person-0-1-2.svg'),
            meaning: 'Nada probable',
            instruction: [
                { bold: false, text: 'Lamentamos lo sucedido, ' },
                { bold: true, text: '¿qué salió mal? ' }
            ],
            nps: 'detractor'
            },
            {
            id: 3,
            img: require('@/assets/nps/person-3-4.svg'),
            meaning: 'Poco probable',
            instruction: [
                { bold: false, text: '¡Oh no!, ' },
                { bold: true, text: '¿en qué podemos mejorar? ' }
            ],
            nps: 'detractor'
            },
            {
            id: 4,
            img: require('@/assets/nps/person-3-4.svg'),
            meaning: 'Poco probable',
            instruction: [
                { bold: false, text: '¡Oh no!, ' },
                { bold: true, text: '¿en qué podemos mejorar? ' }
            ],
            nps: 'detractor'
            },
            {
            id: 5,
            img: require('@/assets/nps/person-5-6.svg'),
            meaning: 'Algo probable',
            instruction: [
                { bold: false, text: 'Entiendo, ' },
                { bold: true, text: '¿en qué podemos mejorar? ' }
            ],
            nps: 'detractor'
            },
            {
            id: 6,
            img: require('@/assets/nps/person-5-6.svg'),
            meaning: 'Algo probable',
            instruction: [
                { bold: true, text: '¿Qué debemos mejorar para ser muy recomendados? ' }
            ],
            nps: 'detractor'
            },
            {
            id: 7,
            img: require('@/assets/nps/person-7-8.svg'),
            meaning: 'Probable',
            instruction: [
                { bold: true, text: '¿Qué debemos mejorar para ser muy recomendados? ' }
            ],
            nps: 'pasivo'
            },
            {
            id: 8,
            img: require('@/assets/nps/person-7-8.svg'),
            meaning: 'Probable',
            instruction: [
                { bold: true, text: '¿Qué debemos mejorar para ser muy recomendados? ' }
            ],
            nps: 'pasivo'
            },
            {
            id: 9,
            img: require('@/assets/nps/person-9.svg'),
            meaning: 'Muy probable',
            instruction: [],
            nps: 'promotor'
            },
            {
            id: 10,
            img: require('@/assets/nps/person-10.svg'),
            meaning: 'Extremadamente probable',
            instruction: [],
            nps: 'promotor'
            }
        ],
    }
    },
    watch: { 
    param: function (query) { // watch it
        this.param = query
        this.showUseRating()
    }
    },
    mounted() {
    this.param = this.query
    },
    computed: {
        currentRating() {
            return this.isRatingSet ? this.rating : (this.half ? this.temporaryRating - 0.5 : this.temporaryRating || this.rating);
        }
    },
    methods: {
    showUseRating () { // busqueda por query, showUseRating & reset data
        this.loader = true
        let BASE_URL = this.api.url
        const requestOptions = {
        method: 'GET',
        headers: { "Content-Type": "application/json" }
        }
        
        fetch(BASE_URL + '/rating?numeroDocumento='+this.param.numeroDocumento, requestOptions)
        .then(response => response.json())
        .then(data => {
            //- console.log('data:', data)
            this.loader = false
            if (data.code == '01') {
            //- loadB = data.data.rows
            this.dataRating = data.data
            this.responseClient.id = this.dataRating.id
            this.mainModal = true
            } else {
            throw new Error(data.message)
            }
        })
        .catch((error) => {
            console.log('error: ', error)
            this.loader = false
        });
    },
    responseMainModal (answer) {
        this.mainModal = false
        this.responseClient.benefit_use = answer
        if (answer == 'no') {
        this.noModal = true
        } else {
        this.yesModal = true
        }
    },
    inputComment (event) {
        console.log('event: ', event.target.value)
    },
    sendModal () {
        this.noModal = false
        this.yesModal = false
        this.gratitudeModal = true
        this.updateCommentRating()
    },
    updateCommentRating () {
        let BASE_URL = this.api.url
        const requestOptions = {
        method: 'PUT',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.responseClient)
        }
        
        fetch(BASE_URL + '/rating', requestOptions)
        .then(response => response.json())
        .then(() => {
            //- console.log('RESPONSE:', data)
            this.gratitudeModal = false
        })
        .catch((error) => {
            console.log('error: ', error)
        });
    },
    selectScoreNps (id) {
      this.responseClient.rating_value = id
      this.scoreData.forEach(objScore => {
        if (this.score === objScore.id) {
          this.selectedScoreInfo = objScore
        }
      })
      this.updateCommentRating()
    },
    }
}

</script>

<style scoped>
/* MODAL GENERAL */ 

#popup-notification .popup-notification__modal.modal-container {
    width: 370px;
}
#popup-notification .popup-notification__modal.modal-container .close {
    text-align: right;
    position: relative;
}
#popup-notification .popup-notification__modal.modal-container .close svg {
    position: absolute;
    cursor: pointer;
    top: -1.5rem;
    right: -1rem;
}
#popup-notification .popup-notification__modal .modal-body {
    padding: 0;
    margin: 0;
    text-align:left;
}
#popup-notification .popup-notification__modal button {
    width: 88px;
    height: 40px;
    cursor: pointer;
    border-style: none;
    border-radius: 8px;
    font-size: 18px;
    margin: 0 20px auto;
    user-select: none;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)!important;
}
#popup-notification .popup-notification__modal button.yes {
    border-style: none;
    background-color: #EA0C90;
    color: #fff;
}
#popup-notification .popup-notification__modal button.no {
    border-style: none;
    background-color: #EA0C90;
    color: #fff;
    color: #0855C4;
    border: 1px solid #0855C4;
    background-color: #fff;
    user-select: none;
}
.stop-scrolling {
    height: 100%;
    overflow: hidden;
}
/*MODAL LOADER */

#popup-notification .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.32);
    display: table;
    transition: opacity 0.3s ease;
    }
    
    #popup-notification .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    }
    #popup-notification .modal-container {
    max-width: calc(100vw - 48px);
    margin: 24px;
    margin-right: auto;
    margin-left: auto;
    width: calc(100% - 48px);
    max-height: 90vh;
    overflow-y: auto;
    padding: 35px 21px ;
    background: #fff;
    border-radius: 7px;
    box-shadow: 0px 4px 4px 0 rgb(0 0 0 / 25%);
    }
    #popup-notification #modal-loader .modal-body {

    }
    #popup-notification #modal-loader .modal-container {
    width: 300px;
    height: 74px;
    min-height: auto;
    overflow-y: hidden;
    padding: 14px;
    border-radius: 0px;
    background-color: #0855c4 !important;
    transition: all 0.3s ease;
    }
    
    #popup-notification .modal-header h3 {
    margin-top: 0;
    color: #42b983;
    }
    
    
    
    #popup-notification .modal-default-button {
    float: right;
    }
    #popup-notification .modal-container .beneficios-vm__actions__box {
    margin-bottom: 14px;
    }
    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.☺
    */
    
    #popup-notification .modal-enter {
    opacity: 0;
    }
    
    #popup-notification .modal-leave-active {
    opacity: 0;
    }
    
    .modal-enter .modal-container,
    #popup-notification .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    }
    
    #popup-notification .bg-loader p { 
    font-size: 14px;
    color: #fff;
    margin: 0;
    margin-bottom: 14px;
    }
    #popup-notification .progress{
    position: relative;
    background-color: rgb(255 255 255 / 30%);
    width: 100%;
    height: 10px; 
    }
    #popup-notification .progress div {
        position: absolute;
    background: #fff;
    width: 0;
    height: 10px;
    animation: progres 1s infinite linear;
    }
    @keyframes progres{
        0%{
        width: 0%;
        }
        20%{
        left: 0;
        width: 30%;
        }
        40%{
            left: 40px;
            width: 30%;
        }
    
        60%{
            left: 60px;
            width: 50%;
        }
        80%{
            left: 35%;
            width: 64%;
        }
        90%{
        left: 50%;
            width: 49%;
        }
        100%{
        left: 65%;
            width: 34%;
        }
    }

    /* General */ 
    #popup-notification  * {
    color: #535D66;
    font-family: "Sofia ProRegular", sans-serif!important;
    }
    #popup-notification p, #popup-notification h1, 
    #popup-notification h2, #popup-notification h3, 
    #popup-notification h4, #popup-notification h5, 
    #popup-notification h6 {
    margin: 0;
    padding: 0;
    }
    #popup-notification .text-center {
    text-align: center;
    }
    #popup-notification .flex {
    display:flex;
    }
    
    #popup-notification .align-center {
    align-items: center;
    }
    #popup-notification .popup-text-primary {
    color: #0855c4!important;
    }
    #popup-notification .popup-text-light {
    color: #C9C9C9!important;
    }
    #popup-notification input {
    border: none;
    border-bottom: 1px solid #C4C4C4;
    width: 80%;
    outline: none;
    }
    #popup-notification .modal-container::-webkit-scrollbar {
    width: 7px;
    }
    #popup-notification .modal-container::-webkit-scrollbar-thumb {
    background:  rgb(0 0 0 / 25%);
    }
    #popup-notification .modal-container::-webkit-scrollbar, 
    #popup-notification .modal-container::-webkit-scrollbar-track, 
    #popup-notification .modal-container::-webkit-scrollbar-thumb {
    border-radius: 45px;
    height: 20px;
    margin-top: 16px;
    margin-bottom: 16px;
    }
    
    #popup-notification .paddingb-3 {
    padding-bottom: 12px !important;
    }
    #popup-notification .paddingr-3 {
    padding-right: 12px !important;
    }
    #popup-notification .paddingl-3 {
    padding-left: 12px !important;
    }
    #popup-notification .paddingx-3 {
    padding-right: 12px !important;
    padding-left: 12px !important;
    }
    #popup-notification .paddingx-5 {
    padding-right: 24px !important;
    padding-left: 24px !important;
    }
    #popup-notification .paddingb-5 {
    padding-bottom: 24px !important;
    }
    #popup-notification .marginy-3 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
    }
    #popup-notification .margint-2 {
    margin-top: 8px !important;
    }
    #popup-notification .margint-3 {
    margin-top: 12px !important;
    }
    #popup-notification .margint-5 {
    margin-top: 20px !important;
    }
    #popup-notification .display-inline {
    display: inline !important;
    }

    #popup-notification .marginy-2 {
    margin-top: 8px!important;
    margin-bottom: 8px!important;
    }
    
    /* Modal Notification */
    #popup-notification .popup-notification__modal .flex img {
    width: 88px;
    height: 56px;
    margin-right: 1rem;
    }

    .nps-benefit-rating .score-list {
        list-style: none;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        column-gap: 11px;
        row-gap: 21px;
        margin: 20px auto 20px;
        width: 90%;
    }

    .nps-benefit-rating .score-list .item {
        width: 34px;
        height: 34px;
        border: 2px solid #FFD645;
        border-radius: 50%;
        color: #FFD645;
        cursor: pointer;
        font-size: 18px;
        line-height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: .2s ease-in-out;
        user-select: none;
    }

    .nps-benefit-rating .score-list .item.low-score {
        border-color:var(--fuchsia-color);
        color: var(--fuchsia-color);
    }

    .nps-benefit-rating .score-list .item.high-score {
        border-color:#00B28D;
        color: #00B28D;
    }

    .nps-benefit-rating .score-list .item.selected {
        background: #FFD645;
        color: #fff;
    }

    .nps-benefit-rating .score-list .item.low-score.selected {
        background: var(--fuchsia-color);
    }

    .nps-benefit-rating .score-list .item.high-score.selected {
        background: #00B28D;
    }
</style>


// WEBPACK FOOTER //
// src/components/vivemas/PopupNotification.vue